import { useBetween } from "use-between";
import { useEffect } from "react";
import { PermissionsUseBetween } from "../use-between/permissions-use-between";
import { getClaims } from "../services/permissions.service";

export default function PermissionsInitialize() {
    const { setClaims } = useBetween(PermissionsUseBetween);

    const ensureClaims = () => {
        getClaims().then((response) => {
            if (response) {
                setClaims(response.data);
            }
        })
    }
    useEffect(() => {
        ensureClaims();
    }, []);
    
    return (
        <></>
    )
}